import { getStoredUserInfo } from "./storage";

export const injectToken = async () => {
  try {
    const stored = getStoredUserInfo();

    if (!stored) {
      console.error("No userInfo found in localStorage");
      return null;
    }

    const { token } = stored;

    if (!token) {
      console.error("No token found in userInfo");
      return null;
    }

    return {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
  } catch (error) {
    console.error("Error reading token:", error);
    return null;
  }
};